import styled from 'styled-components';

export const ListWidthLimiter = styled.div`
  max-width: 24.4rem;
`;
